module.exports = __webpack_public_path__ + "static/media/f1-logo2.345cf931.jpg";